import { PublicHeader } from '@/components/PublicHeader';
import { PublicFooter } from '@/components/PublicFooter';
import { Mail, Phone, MapPin, Headphones, Wrench, CreditCard, Globe, FileText } from 'lucide-react';
import { Link } from 'react-router-dom';

const SupportPage = () => {
  return (
    <div className="min-h-screen bg-background">
      <PublicHeader />

      <main className="max-w-4xl mx-auto px-6 py-12">
        <article data-testid="support-content">
          <div className="mb-8 pb-6 border-b border-border">
            <div className="flex items-center gap-3 mb-2">
              <Headphones className="w-8 h-8 text-primary" />
              <h1 className="text-3xl font-['Oswald'] font-bold tracking-wider uppercase m-0">
                Kundensupport
              </h1>
            </div>
            <p className="text-sm text-muted-foreground mt-2">
              Wir sind für dich da. Bei Fragen rund um deine Mitgliedschaft, Veranstaltungen, Zahlungen oder das Mitgliederportal findest du hier die richtigen Anlaufstellen.
            </p>
          </div>

          <div className="space-y-6 text-foreground/90">
            {/* Allgemeine Anfragen */}
            <section className="bg-card border border-border p-6">
              <h2 className="font-['Oswald'] text-xl font-bold uppercase tracking-wider mb-4 text-primary flex items-center gap-2">
                <Mail size={20} />
                Allgemeine Anfragen
              </h2>
              <p className="mb-4">Für allgemeine Fragen zum Verein, zur Mitgliedschaft oder zu Veranstaltungen:</p>
              <div className="space-y-2">
                <div className="flex items-center gap-3">
                  <Mail size={16} className="text-primary flex-shrink-0" />
                  <a href="mailto:info@shrt.ch" className="text-primary hover:underline">info@shrt.ch</a>
                </div>
                <div className="flex items-center gap-3">
                  <Phone size={16} className="text-primary flex-shrink-0" />
                  <a href="tel:+41794153031" className="text-primary hover:underline">+41 79 415 30 31</a>
                </div>
                <div className="flex items-start gap-3 mt-3 pt-3 border-t border-border">
                  <MapPin size={16} className="text-primary flex-shrink-0 mt-0.5" />
                  <div>
                    <p className="font-bold">S.H.R.T. – Swiss Historic Racing Team</p>
                    <p className="text-sm text-muted-foreground">Verein gemäss Art. 60 ff. ZGB</p>
                    <p>St. Niklausstrasse 1</p>
                    <p>CH-4502 Solothurn</p>
                    <p>Schweiz</p>
                  </div>
                </div>
              </div>
            </section>

            {/* Technischer Support */}
            <section className="bg-card border border-border p-6">
              <h2 className="font-['Oswald'] text-xl font-bold uppercase tracking-wider mb-4 text-primary flex items-center gap-2">
                <Wrench size={20} />
                Technischer Support
              </h2>
              <p className="mb-4">Bei technischen Problemen mit dem Mitgliederportal, der App oder deinem Benutzerkonto:</p>
              <div className="space-y-2">
                <p className="font-bold">Thomas Barth</p>
                <div className="flex items-center gap-3">
                  <Mail size={16} className="text-primary flex-shrink-0" />
                  <a href="mailto:barththomas@mac.com" className="text-primary hover:underline">barththomas@mac.com</a>
                </div>
                <div className="flex items-center gap-3">
                  <Phone size={16} className="text-primary flex-shrink-0" />
                  <a href="tel:+41768318710" className="text-primary hover:underline">+41 76 831 87 10</a>
                </div>
              </div>
            </section>

            {/* Zahlungen */}
            <section className="bg-card border border-border p-6">
              <h2 className="font-['Oswald'] text-xl font-bold uppercase tracking-wider mb-4 text-primary flex items-center gap-2">
                <CreditCard size={20} />
                Zahlungen & Rechnungen
              </h2>
              <p className="mb-4">Bei Fragen zu Zahlungen, Rechnungen, Rückerstattungen oder Zahlungsmethoden (Kreditkarte, TWINT):</p>
              <div className="flex items-center gap-3">
                <Mail size={16} className="text-primary flex-shrink-0" />
                <a href="mailto:info@shrt.ch" className="text-primary hover:underline">info@shrt.ch</a>
              </div>
              <p className="text-xs text-muted-foreground mt-3">
                Zahlungen werden über <strong>Stripe</strong> sicher abgewickelt. Der Verein hat keinen Zugriff auf deine Kreditkartendaten.
              </p>
            </section>

            {/* Mitgliederportal */}
            <section className="bg-card border border-border p-6">
              <h2 className="font-['Oswald'] text-xl font-bold uppercase tracking-wider mb-4 text-primary flex items-center gap-2">
                <Globe size={20} />
                Mitgliederportal
              </h2>
              <p className="mb-3">Das Mitgliederportal erreichst du unter:</p>
              <a href="https://member.shrt.ch" className="text-primary font-bold hover:underline">member.shrt.ch</a>
              <p className="text-xs text-muted-foreground mt-3">
                Dort kannst du dein Profil verwalten, dich für Events anmelden, Rechnungen einsehen und den Marktplatz nutzen.
              </p>
            </section>

            {/* Weitere Infos */}
            <section className="bg-card border border-border p-6">
              <h2 className="font-['Oswald'] text-xl font-bold uppercase tracking-wider mb-4 text-primary flex items-center gap-2">
                <FileText size={20} />
                Weitere Informationen
              </h2>
              <ul className="space-y-2">
                <li><Link to="/datenschutz" className="text-primary hover:underline">Datenschutzerklärung</Link></li>
                <li><Link to="/agb" className="text-primary hover:underline">Allgemeine Geschäftsbedingungen</Link></li>
                <li><Link to="/impressum" className="text-primary hover:underline">Impressum</Link></li>
              </ul>
            </section>
          </div>
        </article>
      </main>

      <PublicFooter />
    </div>
  );
};

export default SupportPage;
